import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, isDevMode } from '@angular/core';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClientModule } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideTranslateLoader } from './app/translate.loader';

bootstrapApplication(AppComponent, {
  providers: [
    /* --- Ionic core --------------------------------------------------- */
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),

    /* --- Angular Router (lazy-load everything & preload after) -------- */
    provideRouter(routes, withPreloading(PreloadAllModules)),

    /* --- Angular HttpClient (needed for ngx-translate) ----------------- */
    importProvidersFrom(HttpClientModule),

    /* --- Ionic Storage (key-value persistence) ------------------------ */
    importProvidersFrom(IonicStorageModule.forRoot()),

    /* --- ngx-translate loader ----------------------------------------- */
    provideTranslateLoader(),

    /* --- Service Worker (PWA support) --------------------------------- */
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch(err => console.error(err));
